import { render, staticRenderFns } from "./SelectOrNew.vue?vue&type=template&id=8b0063b4&lang=pug&"
import script from "./SelectOrNew.vue?vue&type=script&lang=js&"
export * from "./SelectOrNew.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports